import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import { SpecificationEmbodimentImprovementModel, type SpecificationEmbodimentImprovementState } from '../specification-embodiment-improvement-model';

@injectable()
export class SpecificationEmbodimentImprovementModelImpl extends AbstractModel<SpecificationEmbodimentImprovementState> implements SpecificationEmbodimentImprovementModel {
    protected _modelData: SpecificationEmbodimentImprovementState = {
        improvingOutlineNumber: undefined,
        modifiedOutline: undefined,
    };

    get modelData(): SpecificationEmbodimentImprovementState {
        return this._modelData;
    }
}
